module.exports = __webpack_public_path__ + "static/media/RKBrowser6w721@1x.ed3772e9.jpg";